import React from 'react'
import PropTypes from 'prop-types'

import './Layout.css'
import classNames from 'classnames'


/** See the scss definitions to understand more about these options */
const Layout = ({tag='div',page,left,centered,nogutter,regutter,background,className,themed,children}) => (
  React.createElement(tag,{
    className: classNames(
      'layout', {
        'layout--themed': themed,
        'layout--page': page,
        'layout--left':left,
        'layout--centered':centered,

        'layout--nogutter':nogutter,
        'layout--regutter':regutter,
        'layout--with-background':Boolean(background)
      },
      className
    )
  },(
    <React.Fragment>
      {background
        ? <div className="layout--nogutter layout__background" style={{backgroundImage:`url(${background})`}}></div>
        : null
      }
      {children}
    </React.Fragment>
  ))
)

/* Hero
 * ~~~~
 */
Layout.Hero = ({children, className, ...props}) => (
  <Layout {...props} className={classNames(className, "layout--hero")}>
    <div className="layout__content">{children}</div>
  </Layout>
)


/*
 * Wizard
 * ~~~~~~
 * The wizard view - this places buttons overlayed (fixed) at the bottom of a scrollable
 * screen.
 */
Layout.Wizard = ({buttons, hero, children, className,...props}) => (
  <Layout {...props} className={classNames(className,"layout--wizard",hero && "layout--hero")}>
    <div className="layout__content">{children}</div>
    {Boolean(buttons) && (
      <div className="layout__wizard-buttons">
        {buttons}
      </div>
    )}
  </Layout>
)

export default Layout;



// WEBPACK FOOTER //
// ./src/Components/UI/Layout/Layout.js